// A request as the curl command that sends it, for "Copy as API call". The
// token is the consumer's WarmHub token, never one the Console holds. See
// Design > Exchange, "Consumer API".

import type { AskRequest } from "./types.ts";

export const DEFAULT_API = "https://exchange.warmhub.ai";

export function curlFor(apiBase: string, request: AskRequest): string {
  const body = JSON.stringify(request).replace(/'/g, "'\\''");
  return `curl ${apiBase || DEFAULT_API}/v1/ask \\\n  -H "Authorization: Bearer $WARMHUB_TOKEN" \\\n  -H "Content-Type: application/json" \\\n  -d '${body}'`;
}
